export default {
  loading: true,
  error: null,
  view: 'grid',
  geoLocation: false,
  activeMapBox: null,
  selections: [],
  data: [],
  dataMeta: {},
  per_page: 10,
  page: 1,
  sortBy: 'newest',
  searchTerm: '',
  searchType: 'restaurant',
  requestCounter: 0,
  searchByMoveActive: false,
  searchByMoveLoading: false,
  notPaginatedData: [],
  radius: undefined,
  filters: {
    selections: {
      opened: true,
    },
    search: {
      opened: true,
      // apiField: 'name',
			// defaultCondition: 'contains',
      value: '',
    },
    clubOffers: {
      opened: true,
      anyMeal: false,
      clubOffersOnly: false,
      list: {
        'Breakfast': {},
        'Lunch': {},
        'Afternoon Tea': {},
        'Dinner': {},
      },
    },
    cuisines: {
      opened: true,
      apiField: 'cuisines.description',
			defaultCondition: 'eq',
      list: [],
    },
    awards: {
      opened: true,
      apiField: 'awards.name',
			defaultCondition: 'eq',
      list: [],
    },
    ambiences: {
      opened: true,
      apiField: 'ambiences.description',
			defaultCondition: 'eq',
      list: [],
    },
    privateDining: {
      opened: true,
      value: [],
    },
  },
  sorts: [
    {
			'field': 'venue_live',
			'method': 'desc',
		},
  ],
}
